import { useTranslate } from "@similarweb/i18n-provider";
import { SWReactIcons } from "@similarweb/icons";
import { Button, EmptyState } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

type PageErrorStateProps = {
    resetErrorBoundary: () => void;
};

export const PageErrorState = ({ resetErrorBoundary }: PageErrorStateProps) => {
    const { translate } = useTranslate();

    const renderCtaButton = () => (
        <Button
            onClick={resetErrorBoundary}
            data-automation="manage-signals-error-retry"
        >
            {translate("si.common.refresh")}
        </Button>
    );

    const renderImage = () => <SWReactIcons iconName="empty-state-browser" />;

    return (
        <Flex
            flex="1"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            width="100%"
            minHeight="calc(100vh - 200px)"
            data-automation="manage-signals-error-view"
        >
            <EmptyState
                title={translate("common.error")}
                SvgImage={renderImage}
                CtaButtons={renderCtaButton}
                subtitle={translate("si.common.error.reload")}
            />
        </Flex>
    );
};
